import React, { useState } from 'react';
import { CrowdProvider } from './context/CrowdContext';
import { PrasadamBlueprintModal } from './PrasadamBlueprintModal';
import { CameraModal } from './CameraModal';
import { ZoneStrip } from '../components/queue/ZoneStrip';
import { QueueSummaryBar } from '../components/queue/QueueSummaryBar';
import { ExitRouteStrip, EXIT2_STAGES } from '../components/queue/ExitRouteStrip';
import { SystemTotals } from '../components/queue/SystemTotals';

export const QueueOperationsViewInner: React.FC = () => {
  const [showPrasadamBlueprint, setShowPrasadamBlueprint] = useState<boolean>(false);

  return (
    <div id="qview" className="w-full h-full overflow-y-auto overflow-x-hidden bg-[#f4f5f8] dark:bg-[#111215] text-neutral-900 dark:text-neutral-100 font-sans transition-colors duration-200">
      <div className="w-full max-w-full pb-6 space-y-3.5">
        {/* Summary row: live figures from the cameras (holding areas, release, darshan, queue zones) */}
        <QueueSummaryBar />

        {/* ================= 1. QUEUE ZONES: one live figure per zone, from its start and end cameras ================= */}
        <ZoneStrip />

        {/* ================= 2. EXIT 1: main exit route, live from the cameras of its stages ================= */}
        <ExitRouteStrip onStalls={() => setShowPrasadamBlueprint(true)} />

        {/* ================= 3. EXIT 2: Antharalayam exits to Mouna Muni, live from their cameras ================= */}
        <ExitRouteStrip title="Exit 2 · Antharalayam Exit ➔ Mouna Muni" stages={EXIT2_STAGES} />

        {/* ================= 4. SYSTEM TOTAL: queue zones, exit routes and holding areas, from camera counts ================= */}
        <SystemTotals />
      </div>

      {/* S-17 Prasadam & Laddu Distribution Counters Blueprint Modal */}
      {showPrasadamBlueprint && (
        <PrasadamBlueprintModal
          onClose={() => setShowPrasadamBlueprint(false)}
        />
      )}

      {/* Camera Live Modal */}
      <CameraModal />
    </div>
  );
};

export const QueueOperationsView: React.FC = () => {
  return (
    <CrowdProvider>
      <QueueOperationsViewInner />
    </CrowdProvider>
  );
};
